<template>
  <el-dialog
    :visible="true"
    width="600px"
    @close="$router.replace('/data/products')"
    :close-on-click-modal="false"
  >
    <div
      slot="title"
    >
      {{ title }}
    </div>
    <el-tabs
      v-model="activeName"
      v-loading="loading"
    >
      <el-tab-pane
        label="Alapadatok"
        name="1"
      >
        <el-table
          :data="productData"
          :show-header="false"
          border
        >
          <el-table-column
            prop="label"
          >
            <template slot-scope="scope">
              <strong>{{ scope.row.label }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.tagType || 'danger'"
                size="small"
                v-if="scope.row.tag"
              >
                {{ scope.row.value }}
              </el-tag>
              <span
                v-if="!scope.row.tag"
                style="word-break: normal;"
              >
                {{ scope.row.value }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="Kiszerelések"
        name="2"
      >
        <el-table
          :data="product.pack_types"
          border
        >
          <el-table-column
            label="Megnevezés"
            prop="label"
          >
            <template slot-scope="scope">
              <div><strong>{{ scope.row.pack_type.name }}</strong></div>
              <div>{{ scope.row.barcode }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Db / kiszerelés"
            prop="value"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row.count_per_pack }} db
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="Képek"
        name="3"
      >
        <div v-if="product.images && product.images.length">
          <el-row :gutter="20">
            <el-col
              v-for="image in product.images"
              :key="image.id"
              span="6"
              style="margin-bottom: 10px;"
            >
              <el-image
                :src="image.image.full"
                style="cursor: pointer;"
                fit="contain"
                @click="openImage(image.image.full)"
              />
            </el-col>
          </el-row>
        </div>
        <div v-else>
          Ehhez a termékhez nincsenek képek
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="Készlet"
        name="4"
      >
        <el-table
          :data="stockData"
          class="stock-table"
          border
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table
                :data="scope.row.stocks"
                style="width: 100%;"
                border
              >
                <el-table-column
                  prop="count"
                  label="Mennyiség"
                >
                  <template slot-scope="props">
                    <div v-if="props.row.pack.count_per_pack === 1">{{ props.row.count }} db</div>
                    <div v-if="props.row.pack.count_per_pack > 1">{{ props.row.count }} {{
                      props.row.pack.pack_type.name }}
                    </div>
                    <div><i>Szavatosság: {{ props.row.expiration_date | date }}</i></div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="pack"
                  label="Kiszerelés"
                >
                  <template slot-scope="props">
                    {{ props.row.pack.pack_type.name }} ({{ props.row.pack.count_per_pack }} db /
                    kiszerelés)
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            label="Raktár"
            prop="name"
            min-width="200"
          />
          <el-table-column
            label="Mennyiség"
            prop="pack"
            width="140"
          >
            <template slot-scope="scope">
              {{ getSumStorageStock(scope.row) + ' db' }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="Napló"
        name="5"
      >
        <activity-timeline
          v-if="product && product.activities"
          :activities="product.activities"
          :formatters="activityFormatters"
          :propsMap="propsMap"
        />
      </el-tab-pane>
    </el-tabs>
    <div
      slot="footer"
      class="dialog-footer"
      v-can="['data.product.delete', 'data.product.update']"
    >
      <el-button
        @click="$router.replace('/data/products/update/' + product.id)"
        type="primary"
        icon="el-icon-edit"
        v-can="'data.product.update'"
      >
        Módosítás
      </el-button>
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
        v-can="'data.product.delete'"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteProduct()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          icon="el-icon-delete"
          type="danger"
          style="margin-left: 5px;"
        >
          Törlés
        </el-button>
      </el-popover>
    </div>
  </el-dialog>
</template>

<script>
import ActivityTimeline from '../../../../components/ActivityTimeline';

export default {
  components: { ActivityTimeline },
  props: ['productId'],
  data() {
    return {
      activeName: '1',
      deleteButtonLoader: false,
      deleteConfirmVisible: false,
      title: 'Betöltés folyamatban...',
      loading: false,
      buttonLoading: false,
      filterInput: '',
      product: {},
      productData: [],
      stockData: [],
      activityFormatters: {
        status: status => ({
          value: this.getStatusName(status).label,
          tag: this.getStatusName(status).tag,
        }),
        is_billable: ib => ({
          value: ib ? 'Igen' : 'Nem'
        }),
        is_pos: ib => ({
          value: ib ? 'Igen' : 'Nem'
        }),
        is_promotion: ib => ({
          value: ib ? 'Igen' : 'Nem'
        }),
      },
      propsMap: {
        'name': 'Név',
        'description': 'Leírás',
        'category': 'Kategória', //rel
        'status': 'Státusz',
        'min_stock': 'Kritikus készlet',
        'ctn': 'VTSZ', //rel
        'price': 'Nettó alapár',
        'br_price': 'Bruttó alapár',
        'retailer_price': 'Kisker ár',
        'web_price': 'Web ár',
        'minimum_price': 'Padló ár',
        'vat': 'Áfa', //rel
        'is_billable': 'Számlázandó',
        'is_pos': 'POS termék',
        'is_promotion': 'Promóciós termék',
        'suppliers': 'Beszállítók', //rel
        'origin_country': 'Származási ország',
        'usability_days': 'Szavatosság nap',
        'updated_at': 'Módosítva',
        'created_at': 'Létrehozva',
      }
    };
  },

  async mounted() {
    await this.fetchData();
    this.stockData = await axios.get('api/product-storage-stocks/' + this.productId);
  },
  methods: {
    openImage(path) {
      window.open(path);
    },
    async fetchData() {
      this.loading = true;
      this.product = await axios.get(`api/products/${this.productId}`);
      this.title = this.product.name;
      this.productData = [
        {
          label: 'Azonosító',
          value: this.product.id
        },
        {
          label: 'Név',
          value: this.product.name
        },
        {
          label: 'Leírás',
          value: this.product.description || ''
        },
        {
          label: 'Kategória',
          value: this.product.category ? this.product.category.name : ''
        },
        {
          label: 'Státusz',
          value: this.product.status ? this.getStatusName(this.product.status).label : '',
          tag: true,
          tagType: this.product.status ? this.getStatusName(this.product.status).tag : '',
        },
        {
          label: 'Kritikus készlet',
          value: this.product.min_stock || ''
        },
        {
          label: 'Vámtarifaszám',
          value: this.product.ctn ? this.product.ctn.value : ''
        },
        {
          label: 'Származási ország',
          value: this.product.origin_country ? this.product.origin_country.name : ''
        },
        {
          label: 'Szavatosság nap',
          value: this.product.usability_days ? this.product.usability_days : ''
        },
        {
          label: 'Beszerzési ár',
          value: this.$options.filters.currency(this.product.purchase_price) || ''
        },
        {
          label: 'Nettó alapár',
          value: this.$options.filters.currency(this.product.price) || ''
        },
        {
          label: 'Bruttó alapár',
          value: this.$options.filters.currency(((this.product.vat && this.product.vat.value || 27) / 100 + 1) * (this.product.price || 0))
        },
        {
          label: 'Kisker ár',
          value: this.$options.filters.currency(this.product.retailer_price || 0)
        },
        {
          label: 'Web ár',
          value: this.$options.filters.currency(this.product.web_price || 0)
        },
        {
          label: 'Padló ár',
          value: this.$options.filters.currency(this.product.minimum_price || 0)
        },
        {
          label: 'Áfa',
          value: this.product.vat ? this.product.vat.value + '%' : ''
        },
        {
          label: 'Számlázandó',
          value: this.product.is_billable ? 'Igen' : 'Nem'
        },
        {
          label: 'POS termék',
          value: this.product.is_pos ? 'Igen' : 'Nem'
        },
        {
          label: 'Promóciós termék',
          value: this.product.is_promotion ? 'Igen' : 'Nem'
        },
        {
          label: 'Beszállítók',
          value: this.product.suppliers ? this.product.suppliers.map(supp => supp.company.name)
            .join(', ') : ''
        },
        {
          label: 'Módosítva',
          value: this.$options.filters.dateTime(this.product.updated_at) || ''
        },
        {
          label: 'Létrehozva',
          value: this.$options.filters.dateTime(this.product.created_at) || ''
        },
      ];
      this.loading = false;
    },
    async deleteProduct() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('product/delete', this.productId);
        this.$store.dispatch('product/fetchAllWithPagination');
        this.$router.replace('/data/products');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    },

    getStatusName(status) {
      switch (status) {
        case 'inactive':
          return {
            label: 'Inaktív',
            tag: 'danger',
          };
        case 'active':
          return {
            label: 'Aktív',
            tag: 'success',
          };
        case 'run-out':
          return {
            label: 'Kifutó',
            tag: 'primary',
          };
        case 'run-out-inactive':
          return {
            label: 'Kifutó és inaktív',
            tag: 'warning',
          };
        case 'hidden':
          return {
            label: 'Láthatatlan',
            tag: 'info',
          };
        default:
          return {
            label: '',
            tag: 'info',
          };
      }
    },

    getSumStorageStock(storage) {
      let sum = 0;
      storage.stocks.forEach(stock => {
        sum += stock.count * stock.pack.count_per_pack;
      });
      return sum;
    }
  },
};
</script>
<style lang="scss">
  .stock-table {
    .product-column {
      .cell {
        word-break: break-word;
      }
    }
  }

</style>

